<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <gg-toolbar @close="close">
        Rename MySQL user
      </gg-toolbar>

      <v-card-text>
        <v-row >
          <v-col cols="12">
            <p>Old name: <strong>{{ user.user }}</strong></p>
          </v-col>
        </v-row>
        <v-text-field outlined
                      label="New Name"
                      name="New Name"
                      v-model="name"
                      :counter="maxlength"
                      :prefix="namePrefix"
                      v-validate="`required|max:${maxlength}`"
                      :error-messages="errors.collect('New Name')"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <gg-btn :loading="loading"
               class="ml-0 mb-0"
               tile
               color="primary"
               @click="renameUser">Rename</gg-btn>
        <gg-btn class="mb-0" @click="close" text color="primary">Cancel</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RenameUserModal',
  props: {
    user: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
      name: '',
    }
  },
  computed: {
    ...mapGetters(['mysqlRestrictions', 'hosting']),
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
    namePrefix () {
      return this.mysqlRestrictions ? this.mysqlRestrictions.prefix : ''
    },
    maxlength () {
      if (typeof this.mysqlRestrictions.max_username_length !== 'undefined') {
        if (typeof this.mysqlRestrictions.prefix !== 'undefined') {
          return this.mysqlRestrictions.max_username_length - this.mysqlRestrictions.prefix.length
        }
        return this.mysqlRestrictions.max_username_length
      }
      return 16
    },
    newName () {
      return this.namePrefix + this.name
    },
  },
  methods: {
    ...mapActions(['renameMysqlUser', 'reportSuccess', 'reportError']),
    close () {
      this.$emit('close')
    },
    renameUser () {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return
        }
        this.loading = true
        this.renameMysqlUser({ oldname: this.user.user, newname: this.newName, _username: this.$route.query.user })
          .then(() => {
            this.reportSuccess(`User “${this.user.user}” renamed to “${this.newName}”.`)
            this.loading = false
            this.$emit('action-completed', 'user-renamed')
          })
          .catch((error) => {
            this.reportError(error)
            this.loading = false
          })
      })
    }
  },
}
</script>
